<template>
  <div>
    <div class="fullbanner" :class="{ fullbannerH: movieTag }">
      <div class="bannerC" v-if="mybgData">
        <el-carousel
          autoplay
          height="500px"
          class="carousel"
          trigger="click"
          @change="bgLoad"
          :interval="5000"
        >
          <el-carousel-item v-for="item in mybgData" :key="item.id">
            <img
              :src="item.img_url"
              alt=""
              :class="item.link ? 'bgImg' : ''"
              ref="bgImg"
              @load="bgLoad(0)"
              @click="bannerLink(item)"
            />
          </el-carousel-item>
        </el-carousel>
        <div class="movice">
          <div class="head" v-if="movieTag">
            <div class="tabBox">
              <ul class="b">
                <li
                  v-for="(item, index) in movieTag"
                  :key="index"
                  :class="{ active: item.active }"
                  @click="jumpAfter(item)"
                >
                  <span v-if="!item.is_hide">
                    {{ item.title }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultLogo from '@/assets/images/birthday/no_banner.jpg';
import { banner_click } from '@/service/index';
export default {
  name: 'revisionBackground',
  props: ['bgData', 'movieTag'],
  data() {
    return {
      defaultLogo,
      mybgData: null,
      // mybgData: [
      //   {
      //     id: 0,
      //     img_url: defaultLogo,
      //     link: '1'
      //   }
      // ],
      mymovieTag: null
    };
  },
  watch: {
    bgData: {
      handler(val) {
        if (val && val.length > 0) {
          this.mybgData = val;
        } else {
          this.mybgData = null;
          // this.mybgData = [
          //   {
          //     id: 0,
          //     img_url: defaultLogo,
          //     link: '1'
          //   }
          // ];
        }
      },
      immediate: true,
      deep: true
    },
    movieTag(val) {
      if (val) {
        this.mymovieTag = val;
      }
    }
  },
  methods: {
    bgLoad(index) {
      this.$nextTick(() => {
        const imgs = this.$refs['bgImg'] || [];
        const img = imgs[index] || imgs[0];
        let clientWidth = img ? img.clientWidth : 0;
        // 图还没排出版宽度就别写，否则会把背景墙的宽度写成 0（整块就看不见了）
        if (!clientWidth) return;
        // 上限取「组件自己的宽度」（版心页面 1150px／满屏页面 = 视口宽），不要取 body 的视口宽：
        // 取视口宽时图在版心页会超出这一列，虽然靠 overflow: hidden 也能裁掉，
        // 但轮播左右箭头在列的边缘外会一起被裁掉看不见；按容器宽写，箭头留在可视范围内，
        // 图本身在 .el-carousel__item（flex 居中 + overflow: hidden）里居中裁切
        const wrapWidth = this.$el.clientWidth || document.body.clientWidth;
        if (clientWidth > wrapWidth) clientWidth = wrapWidth;
        // 只在组件内部找目标元素：原来用 document.querySelector 全局找，
        // 页面上若有同名 .carousel（比如页面自己的轮播）会把宽度写到别的元素上，背景墙自己仍是 0 宽
        ['.carousel', '.movice'].forEach(sel => {
          const dom = this.$el.querySelector(sel);
          if (dom) dom.setAttribute('style', `width:${clientWidth}px;`);
        });
      });
    },
    jumpAfter(item) {
      let obj = this.movieTag.map(data => {
        if (data.title == item.title) {
          data.active = true;
        } else {
          data.active = false;
        }
        return data;
      });
      this.$emit('changeMtag', obj);
      let ele = document.body;
      let height = ele.scrollTop;
      this.$router.push({ path: item.path });
      ele.scrollTop = height;
    },
    bannerLink(item) {
      banner_click({ id: item.id }); //统计点击次数
      if (!item.link) return;
      // 项目内路径（getBanner 已截掉域名）走路由跳转，外部地址沿用新窗口
      if (item.link.charAt(0) === '/') {
        this.$router.push(item.link);
      } else {
        window.open(item.link);
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.fullbanner {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  // 超出隐藏：图是按原图比例撑开的，兜底防住「宽度没收紧/写了比容器更宽的值」时
  // 把整页撑出横向滚动条（迁移到本组件前是各页面 .bannerBox { width: 1150px; overflow: hidden } 兜的）
  overflow: hidden;
  .bgWidth {
    visibility: hidden;
  }
  .bgImg {
    cursor: pointer;
  }
}
.bannerC {
  // position: absolute;
  // 兜底宽度：宽度本来是靠 bgLoad（图片 load 事件）写死的，
  // 没跑到时这块会塌成 0 宽导致「有 banner 数据却看不见」（el-carousel__item 是 absolute，撑不开父级）
  min-width: 100%;
  .carousel,
  .movice {
    // 居中裁切：这个宽度是 bgLoad 按图片实际宽度写进来的（可能比容器窄，也可能被收到容器宽），
    // 用 left + translate 水平居中（不能用 margin: 0 auto —— 子项比容器宽时 auto 边界会退化成 0，变成左对齐）；
    // 被收到容器宽时，超出部分由 .el-carousel__item（flex 居中 + overflow: hidden）居中裁切
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
}
.movieTag {
  height: 580px;
}
.movice {
  .head {
    width: 100%;
    .tabBox {
      width: 100%;
      padding: 0;
      ul {
        height: 80px;
        background: #fff;
        list-style: none;
        justify-content: center;
        line-height: 80px;
        li {
          color: #666666;
          font-size: 26px;
          cursor: pointer;
          margin-right: 114px;
          // &:nth-child(1) {
          // }
          &:nth-last-of-type(1) {
            margin-right: 0;
          }
        }
        .active {
          @include color_primary($color-primary);
          border-bottom: 3px solid #f44141;
          @include border_color($border-color);
        }
      }
    }
    .bannerBox {
      width: 1150px;
      height: 400px;
      overflow: hidden;
      .carousel {
        width: 100%;
        /deep/ .el-carousel__arrow {
          font-weight: bold;
          font-size: 20px;
          background: rgb(31, 45, 61);
          opacity: 0.6;
          &:hover {
            opacity: 0.8;
          }
        }
        /deep/ .el-carousel__container {
          width: 1150px;
          /deep/ button {
            top: 52%;
          }
        }
        .item {
          width: 100%;
          .imgBox {
            width: 100%;
            img {
              width: 100%;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.el-carousel__item {
  display: flex;
  justify-content: center;
  background: #f4f4f4;
  img {
    width: auto;
    height: 100%;
    // width: 100%;
    // &:nth-of-type(1) {
    //   width: 1500px;
    // }
  }
}
.fullbanner {
  /deep/ .el-carousel__arrow {
    font-weight: bold;
    font-size: 20px;
    background: rgb(31, 45, 61);
    opacity: 0.6;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
